export default __webpack_public_path__ + "static/media/cardEficacia.7c6a7e41.png";